import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import es from './locales/es.json';
import en from './locales/en.json';
import pt from './locales/pt.json';

const resources = {
  es: { translation: es },
  en: { translation: en },
  pt: { translation: pt }
};

const detectLang = () => {
  // 1) Preferencia guardada por i18next (por cambios manuales en la UI)
  try {
    const stored = sessionStorage.getItem('i18nextLng');
    if (stored && ['es', 'en', 'pt'].includes(stored)) return stored;
  } catch (e) {}

  // 2) Idioma preferido desde el backend (establecido en el login)
  try {
    const preferred = sessionStorage.getItem('idioma_preferido');
    if (preferred && ['es', 'en', 'pt'].includes(preferred)) return preferred;
  } catch (e) {}

  // 3) Detecta idioma del navegador si no hay preferencia guardada
  if (typeof navigator !== 'undefined') {
    const nav = (navigator.language || navigator.userLanguage || 'es').toLowerCase();
    if (nav.startsWith('es')) return 'es';
    if (nav.startsWith('pt')) return 'pt';
    if (nav.startsWith('en')) return 'en';
  }

  // 4) Fallback
  return 'es';
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: detectLang(),
    fallbackLng: 'es',
    debug: false,
    interpolation: {
      escapeValue: false
    }
  });

export const changeLanguage = (lng) => {
  i18n.changeLanguage(lng);
  try { sessionStorage.setItem('i18nextLng', lng); } catch (e) {}
};

export default i18n;
